
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { readCookie } from '@/tools/tools';
import { pageVisit, saveFeedBack, uploadFile } from '@/services/http';

@Component({
  components: {
    Header,
    Footer,
    DropDown,
    NavMenu
  }
})
export default class extends Vue {
  content: string = ''

  isRemark: boolean = false

  mobileNo: string = ''

  feedbackType: number = 1

  fileList: any[] = []

  currentIndex: number = 0

  // 上传图片id
  imageIds: string = ''

  feedbackList: any[] = [
    {
      name: '功能异常',
      id: 1
    },
    {
      name: '体验问题',
      id: 2
    },
    {
      name: '产品建议',
      id: 3
    },
    {
      name: '其他问题',
      id: 4
    }
  ]

  maxpic: boolean = false // 是否上传到最大数量

  created() {}

  handleChange() {
    this.isRemark = this.content === '';
  }

  // 选择问题类型
  selectFeedBack(id: number, index: number) {
    this.currentIndex = index;
    this.feedbackType = id;
    (this as any).$refs.upload.value = '';
  }

  // 上传图片
  private async uploadpic(event: any) {
    const file = [...event.target.files];
    if (this.fileList.length < 3) {
      const uploadlength = 3 - this.fileList.length;
      const form = new FormData();
      file.forEach((value) => {
        form.append('fileData', value);
        form.append('type', '11');
      });
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        this.fileList = [
          ...this.fileList,
          ...res.data.data.slice(0, uploadlength)
        ];
        this.maxpic = this.fileList.length === 3;
        this.imageIds = this.fileList.map((e) => e.id).join(',');
      } else {
        this.$message.error(res.data.message);
      }
    }
    (this as any).$refs.upload.value = '';
  }

  // 删除上传图片
  private removefile(index: number) {
    this.fileList.splice(index, 1);
    this.maxpic = false;
  }

  // 添加反馈意见
  async saveFeedback() {
    if (this.content === '') {
      this.isRemark = true;
    } else {
      const res: any = await saveFeedBack({
        id: '',
        platform: 2,
        content: this.content,
        imageIds: this.imageIds,
        feedbackType: this.feedbackType,
        mobileNo: this.mobileNo,
        companyId: 1
      });
      if (res.data.code === 100) {
        this.content = '';
        this.currentIndex = 0;
        this.imageIds = '';
        this.fileList = [];
        this.mobileNo = '';
        this.feedbackType = 1;
        this.maxpic = false;
        this.$message.success({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: `
            <p style="margin-bottom: 8px; color: #333; font-size: 14px;">提交成功</p>
            <span style="display: block; color: #999; font-size: 12px;">感谢您给我们提出的宝贵意见，帮助我们完善产品，谢谢！</span>
          `
        });
      }
    }
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 14,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }
}
